import React, { useEffect, useState } from 'react'
import { diagonistics } from '../../Assets/dummyDiagons'
import Header from '../Core/Header'
import { getAllDiagnostics } from '../../Services/Operations/ProductAPI'
import { useSelector } from 'react-redux'

const FindDiagonictics = () => {
    const[list,setList]=useState(diagonistics)
        const token = useSelector((state) =>JSON.parse( state.auth.token));
        const[diagnostics,setDiagnostics]=useState([])


    const handlegetGiagnostics=async()=>{
        try {
            const res= await getAllDiagnostics(token)
            console.log(res);
            if(res.status===200){
                setDiagnostics(res.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

    useEffect(() => {
      handlegetGiagnostics()
    }, [])
    
  return (
    <div style={{height:"100vh",width:"100%"}}>
        <Header/>
     <section
  style={{
    marginTop: "80px",
    height: "calc(100vh - 80px)",
    background: "linear-gradient(135deg, #eef2f7, #ffffff, #e5e7eb)",
    padding: "20px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  }}
>
  {/* Header */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "15px",
      padding: "18px 20px",
      background: "linear-gradient(135deg, #172b4d, #29496e)",
      borderRadius: "14px",
      boxShadow: "0 5px 18px rgba(23, 43, 77, 0.15)",
      marginBottom: "20px",
    }}
  >
    <div>
      <p
        style={{
          color: "#ffffff",
          fontSize: "23px",
          fontWeight: "700",
          margin: 0,
        }}
      >
        All Registered Diagnostic Centers
      </p>

      <p
        style={{
          color: "#d5e2f1",
          fontSize: "13px",
          margin: "6px 0 0",
        }}
      >
        Manage diagnostic centers and their hospital associations
      </p>
    </div>

    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px",
      }}
    >
      <input
        placeholder="Search Diagnostic by Aadhaar"
        style={{
          width: "240px",
          maxWidth: "100%",
          boxSizing: "border-box",
          border: "1px solid #dce3ed",
          borderRadius: "9px",
          fontSize: "14px",
          padding: "11px 14px",
          outline: "none",
          backgroundColor: "#ffffff",
          color: "#1e293b",
        }}
      />

      <button
        type="button"
        onClick={() => {
          // Add your existing Register New navigation/modal logic here
        }}
        style={{
          padding: "11px 17px",
          borderRadius: "9px",
          border: "1px solid #ffffff",
          backgroundColor: "#ffffff",
          color: "#172b4d",
          fontSize: "14px",
          fontWeight: "700",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        + Register New
      </button>
    </div>
  </div>

  {/* Diagnostic Center List */}
  <div
    style={{
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      overflowX: "hidden",
      padding: "2px 4px 15px 2px",
    }}
  >
    {diagnostics?.length > 0 ? (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 270px), 1fr))",
          gap: "20px",
          alignItems: "stretch",
        }}
      >
        {diagnostics.map((item, index) => (
          <div
            key={item?.id || item?.license_number || index}
            style={{
              minWidth: 0,
              borderRadius: "15px",
              padding: "14px",
              backgroundColor: "#ffffff",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 14px rgba(15, 23, 42, 0.07)",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              boxSizing: "border-box",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow =
                "0 10px 25px rgba(15, 23, 42, 0.13)";
              e.currentTarget.style.transform = "translateY(-3px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow =
                "0 4px 14px rgba(15, 23, 42, 0.07)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            {/* Image */}
            <div
              style={{
                height: "165px",
                width: "100%",
                borderRadius: "11px",
                overflow: "hidden",
                backgroundColor: "#e9eef5",
              }}
            >
              <img
                src="/Assets/diagonasitic.jpg"
                alt={item?.center_name || "Diagnostic Center"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>

            {/* Center Details */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                minWidth: 0,
              }}
            >
              <p
                style={{
                  fontSize: "19px",
                  fontWeight: "700",
                  color: "#172b4d",
                  margin: 0,
                  overflowWrap: "anywhere",
                }}
              >
                {item?.center_name || "Unnamed Diagnostic Center"}
              </p>

              {/* License */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  padding: "10px",
                  backgroundColor: "#eff6ff",
                  borderRadius: "9px",
                }}
              >
                <span style={{ fontSize: "16px" }}>▤</span>

                <div style={{ minWidth: 0 }}>
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#64748b",
                      margin: "0 0 3px",
                      fontWeight: "600",
                    }}
                  >
                    LICENSE NUMBER
                  </p>

                  <p
                    style={{
                      fontSize: "13px",
                      color: "#2563a6",
                      fontWeight: "700",
                      margin: 0,
                      overflowWrap: "anywhere",
                    }}
                  >
                    {item?.license_number || "Not available"}
                  </p>
                </div>
              </div>

              {/* Address */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                }}
              >
                <span style={{ fontSize: "17px" }}>📍</span>

                <div style={{ minWidth: 0 }}>
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#64748b",
                      margin: "0 0 3px",
                      fontWeight: "600",
                    }}
                  >
                    ADDRESS
                  </p>

                  <p
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#334155",
                      margin: 0,
                      lineHeight: "1.5",
                      overflowWrap: "anywhere",
                    }}
                  >
                    {item?.address || "Address not available"}
                  </p>
                </div>
              </div>

              {/* Medical Tests */}
              <div
                style={{
                  borderTop: "1px solid #edf0f5",
                  paddingTop: "12px",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#334155",
                    margin: "0 0 9px",
                  }}
                >
                  Medical Tests Provided
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    flexWrap: "wrap",
                  }}
                >
                  {Array.isArray(item?.TestProvided) &&
                  item.TestProvided.length > 0 ? (
                    item.TestProvided.map((test, i) => (
                      <span
                        key={i}
                        style={{
                          fontSize: "11px",
                          padding: "6px 9px",
                          borderRadius: "7px",
                          backgroundColor: "#e8f1ff",
                          color: "#2458a6",
                          fontWeight: "600",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {test}
                      </span>
                    ))
                  ) : (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#94a3b8",
                        fontStyle: "italic",
                      }}
                    >
                      No tests listed
                    </span>
                  )}
                </div>
              </div>

              {/* Assigned Hospitals */}
              <div
                style={{
                  borderTop: "1px solid #edf0f5",
                  paddingTop: "12px",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    color: "#334155",
                    margin: "0 0 9px",
                  }}
                >
                  Assigned Hospitals
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    flexWrap: "wrap",
                  }}
                >
                  {Array.isArray(item?.Hospitals) &&
                  item.Hospitals.length > 0 ? (
                    item.Hospitals.map((hospital, i) => (
                      <span
                        key={i}
                        style={{
                          fontSize: "11px",
                          padding: "6px 9px",
                          borderRadius: "7px",
                          backgroundColor: "#e5f6ed",
                          color: "#176b45",
                          fontWeight: "600",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {hospital}
                      </span>
                    ))
                  ) : (
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#94a3b8",
                        fontStyle: "italic",
                      }}
                    >
                      No hospitals assigned
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div
        style={{
          minHeight: "250px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "#64748b",
          gap: "10px",
        }}
      >
        <div style={{ fontSize: "42px" }}>🏥</div>

        <p
          style={{
            fontSize: "19px",
            fontWeight: "700",
            color: "#334155",
            margin: 0,
          }}
        >
          No Diagnostic Centers Found
        </p>

        <p style={{ fontSize: "14px", margin: 0 }}>
          Registered diagnostic centers will appear here.
        </p>
      </div>
    )}
  </div>
</section>
     
    </div>
  )
}

export default FindDiagonictics
